import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Signup() {
  const { register, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created");
      navigate("/account", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="signup-page">
      <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight text-center">Join laze</h1>
      <p className="text-center text-sm text-zinc-400 mt-2">Create an account to shop the drops.</p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div><Label className="text-xs">Name</Label><Input data-testid="signup-name" value={name} onChange={(e) => setName(e.target.value)} className="bg-zinc-900 border-zinc-800 mt-1.5" /></div>
        <div><Label className="text-xs">Email</Label><Input data-testid="signup-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-zinc-900 border-zinc-800 mt-1.5" /></div>
        <div><Label className="text-xs">Password</Label><Input data-testid="signup-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-zinc-900 border-zinc-800 mt-1.5" /></div>
        <button type="submit" disabled={loading} data-testid="signup-submit" className="w-full rounded-full bg-brand text-black py-3 text-sm font-bold uppercase tracking-wide hover:bg-brand-hover active:scale-95 transition disabled:opacity-60 flex items-center justify-center gap-2">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create Account"}
        </button>
      </form>

      <div className="flex items-center gap-3 my-6"><div className="h-px bg-zinc-800 flex-1" /><span className="font-mono text-[10px] uppercase tracking-widest text-zinc-600">or</span><div className="h-px bg-zinc-800 flex-1" /></div>
      <button onClick={googleLogin} data-testid="google-signup-btn" className="w-full flex items-center justify-center gap-3 rounded-full border border-zinc-700 py-3 text-sm font-semibold hover:border-brand hover:text-brand transition active:scale-95">
        <svg className="h-4 w-4" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 10.2v3.9h5.5c-.24 1.4-1.7 4.1-5.5 4.1-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.7 2.9 14.6 2 12 2 6.9 2 2.8 6.1 2.8 12S6.9 22 12 22c5.6 0 9.3-3.9 9.3-9.4 0-.6-.1-1.1-.2-1.6H12z"/></svg>
        Continue with Google
      </button>

      <p className="text-center text-sm text-zinc-400 mt-8">
        Already have an account? <Link to="/login" data-testid="goto-login" className="text-brand hover:underline">Sign in</Link>
      </p>
    </div>
  );
}
